import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const OnboardingGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { needsOnboarding } = useAuth();
  const location = useLocation();

  // Don't redirect if already on onboarding page
  if (needsOnboarding && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};

export default OnboardingGate;
